/*
 * Attaches the real srcset to images rendered by snippets/deferred-image.liquid once they
 * come near the viewport. See that snippet for why loading="lazy" alone was not enough.
 *
 * Three ways an image here can end up loaded, so a failure anywhere still shows the picture:
 *   1. IntersectionObserver fires  (the normal path)
 *   2. no IntersectionObserver     (attach everything immediately)
 *   3. window load + 2s            (safety net -- an observer that never fires, a section
 *                                   swapped in by the theme editor, a hidden parent, etc.)
 */
(function () {
  var SELECTOR = 'img.deferred-image[data-srcset]';

  function attach(img) {
    if (img.dataset.deferredDone) return;
    img.dataset.deferredDone = '1';
    var srcset = img.dataset.srcset;
    var src = img.dataset.src;
    // Drop the placeholder blur only once the real bytes are in.
    img.addEventListener('load', function onLoad() {
      if (img.currentSrc && img.currentSrc.indexOf('width=20') === -1) {
        img.classList.add('deferred-image--ready');
        img.removeEventListener('load', onLoad);
      }
    });
    if (src) img.src = src;
    if (srcset) img.srcset = srcset;
    img.removeAttribute('data-srcset');
  }

  function attachAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(attach);
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          attach(entry.target);
        });
      },
      // Generous enough that the image is normally there before it is scrolled to, tight
      // enough that it is not simply "load everything" again.
      { rootMargin: '300px 0px', threshold: 0 }
    );
  }

  function observeAll(root) {
    if (!observer) { attachAll(root); return; }
    (root || document).querySelectorAll(SELECTOR).forEach(function (img) { observer.observe(img); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeAll(); });
  } else {
    observeAll();
  }

  /* There was a "safety net" here that attached every remaining image two seconds after the
     load event. It was worth 995 KiB of images nobody had scrolled to -- measured -- and it
     could never have helped: it only runs when JavaScript works, which is the same condition
     under which the observer above has already done the job. A browser with no
     IntersectionObserver is handled by attachAll() in observeAll(), and a browser with no
     JavaScript at all still shows the 20px copy in src. */

  // The theme editor and the theme's own section renderer both replace section markup.
  document.addEventListener('shopify:section:load', function (e) { observeAll(e.target); });
})();
